const TEXT_OPTIONAL = '(valgfritt)';
const TEXT_DATE_FORMAT = 'dd.mm.yyyy';
const ERROR_DATE_TEXT = 'Du må velge både måned og år for å få en gyldig dato';
const YEAR_TEXT = 'År';
const MONTH_TEXT = 'Måned';

export default { TEXT_OPTIONAL, TEXT_DATE_FORMAT, ERROR_DATE_TEXT, YEAR_TEXT, MONTH_TEXT };
